import { UserInfo } from './component';
import { Props } from './props';

export type UserInfoProps = Props;
export * from './component';

export default UserInfo;
